import type { ReactElement } from 'react';
import Checkout from './checkout/Checkout';
import Confirmation from './checkout/Confirmation';
import Cart from './preview/Cart';
import { ROUTES_ID } from './routes/constants';
import { useAppSelector } from './store/hooks';
import Trial from './trial/Trial';
import TrialConfirmation from './trial/TrialConfirmation';

const routesComponentsMap: Record<string, () => ReactElement> = {
  [ROUTES_ID.CART]: () => <Cart />,
  [ROUTES_ID.CHECKOUT]: () => <Checkout />,
  [ROUTES_ID.CONFIRMATION]: () => <Confirmation />,
  [ROUTES_ID.TRIAL]: () => <Trial />,
  [ROUTES_ID.TRIAL_CONFIRMATION]: () => <TrialConfirmation />,
};

function App() {
  const routing = useAppSelector((state) => state.routing);
  const render = routesComponentsMap[routing.id];
  return render ? render() : <Cart />;
}

export default App;
